var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockshieldfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1261_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79883 0.439453C9.93164 0.830078 13.584 2.1582 14.7266 2.62695C15.5469 2.96875 15.9766 3.29102 15.9766 4.29688V11.6602C15.9766 15.166 14.1895 16.6211 8.63281 19.5312C8.38867 19.6582 8.14453 19.7168 7.98828 19.7168C7.83203 19.7168 7.59766 19.668 7.34375 19.5312C1.88477 16.4551 0 15.166 0 11.6602V4.29688C0 3.29102 0.439453 2.95898 1.25 2.62695C2.39258 2.16797 6.04492 0.810547 7.1875 0.439453C7.44141 0.361328 7.71484 0.302734 7.98828 0.302734C8.26172 0.302734 8.53516 0.351562 8.79883 0.439453ZM5.23438 7.34375V8.52539C4.64844 8.56445 4.35547 8.91602 4.35547 9.62891V13.6328C4.35547 14.3848 4.6875 14.7363 5.38086 14.7363H10.5957C11.2891 14.7363 11.6211 14.3848 11.6211 13.6328V9.62891C11.6211 8.91602 11.3281 8.56445 10.7422 8.52539V7.34375C10.7422 5.48828 9.62891 4.23828 7.98828 4.23828C6.34766 4.23828 5.23438 5.48828 5.23438 7.34375ZM9.6875 7.22656V8.51562H6.28906V7.22656C6.28906 6.04492 6.97266 5.26367 7.98828 5.26367C9.00391 5.26367 9.6875 6.04492 9.6875 7.22656Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1261_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7285,
    height: 19.7168
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockshieldfill);
export default __webpack_public_path__ + "static/media/lock.shield.fill.ca9ab01e183b64510ed1f8299d356598.svg";
export { ForwardRef as ReactComponent };